import React, { useState,  useEffect } from 'react';
import styled from 'styled-components';
import { FaUserCircle } from 'react-icons/fa';
import ProfileModal from '../Profile';
import adminBg from '../../Assets/bg/adminbg.jpg';


const NavbarSiquijor = ({ isSidebarExpanded, darkMode,  }) => {
const [isProfileModalVisible, setProfileModalVisible] = useState(false);
const [scrolled, setScrolled] = useState(false);

useEffect(() => {
  const handleScroll = () => {
    setScrolled(window.scrollY > 10);
  };

  window.addEventListener('scroll', handleScroll);
  return () => window.removeEventListener('scroll', handleScroll);
}, []);

  const handleProfileClick = () => {
    setProfileModalVisible(true);
  };

  const handleCloseModal = () => {
    setProfileModalVisible(false);
  };

  useEffect(() => {
   
    if (darkMode) {
      document.body.classList.add('dark-mode');
    } else {
      document.body.classList.remove('dark-mode');
    }
  }, [darkMode]);

  return (
    <NavbarContainer darkMode={darkMode} isSidebarExpanded={isSidebarExpanded} scrolled={scrolled}>
    <p style={{ fontSize: '16px', fontWeight: 'bold', marginLeft: '40%', marginBottom: '10px',  color: darkMode ? '#fff' : '#333' }} darkMode={darkMode} >
    Welcome to Siquijor Dashboard
    </p>
     
  <LeftSection>


      <ProfileWrapper onClick={handleProfileClick}>
        <ProfileIconContainer>
          <FaUserCircle style={styles.profileIcon} />
          <TooltipAccount className="tooltip">Account</TooltipAccount>
        </ProfileIconContainer>
      </ProfileWrapper>
      </LeftSection>
      {isProfileModalVisible && <ProfileModal onClose={handleCloseModal} />}
    </NavbarContainer>
  );
};

export default NavbarSiquijor;

const NavbarContainer = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
  position: fixed;
  top: 0;
  left: ${({ isSidebarExpanded }) => (isSidebarExpanded ? '250px' : '0px')};
  width: ${({ isSidebarExpanded }) => (isSidebarExpanded ? 'calc(100% - 250px)' : '100%')}; 
  padding: 0 10px;
  transition: left 0.3s ease, width 0.3s ease;
  z-index: 1000;

  background-color: ${({ darkMode }) => (darkMode ? 'transparent' : 'white')}; 
  background-image: ${({ darkMode }) => (darkMode ? `url(${adminBg})` : 'none')};
  background-size: cover;
 
 

  /* Optional: Apply box shadow when scrolling */
  box-shadow: ${({ scrolled }) =>
    scrolled ? '0 4px 12px rgba(0, 0, 0, 0.2)' : 'none'};
`;

const LeftSection = styled.div`
  display: flex;
  align-items: center;
  justify-content: flex-start;
`;

const ProfileWrapper = styled.div`
  position: relative;

  &:hover .tooltip {
    opacity: 1;
    visibility: visible;
  }
`;

const ProfileIconContainer = styled.div`
  cursor: pointer;
  color: #4d4d4d;
  font-size: 24px;
  margin-right: 15px;
  display: flex;
  justify-content: center;
  align-items: center;
  background-color: #ffffff;
  border-radius: 50%;
  width: 30px;
  height: 30px;
  border: 2px solid #4d4d4d;
  position: relative;
`;


const TooltipAccount = styled.div`
  visibility: hidden;
  opacity: 0;
  position: absolute;
  bottom: -30px;
  left: 50%;
  transform: translateX(-50%);
  background-color: #333;
  color: #fff;
  padding: 5px 10px;
  font-size: 12px;
  border-radius: 5px;
  transition: opacity 0.3s ease, visibility 0.3s ease;

  ${ProfileWrapper}:hover & {
    visibility: visible;
    opacity: 1;
  }
`;

const styles = {
  icon: (isActive) => ({
    fontSize: '24px',
    color: isActive ? '#28a745' : '#4d4d4d',
    marginRight: '20px',
  }),
  searchIcon: {
    fontSize: '15px',
    color: '#4d4d4d',
  },
  profileIcon: {
    fontSize: '25px',
    color: '#4d4d4d',
  },
};

